export default __webpack_public_path__ + "static/media/404-goose.fc6f6918.gif";